import { Injectable } from '@angular/core';
import { SalesPlanTemplate } from '../reports/sales-plan-template';
import { IExcelTemplate } from '../interfaces/i-excel-template';
import * as ExcelJS from 'exceljs';

@Injectable({
  providedIn: 'root'
})
export class ExcelServiceService {

  constructor() { }

  private getTemplate(templateType: string): IExcelTemplate {
    switch (templateType) {
      case 'SalesPlanTemplate':
        return new SalesPlanTemplate();
      default:
        throw new Error('Invalid template type');
    }
  }

  async generateExcel(templateType: string, data: any[], fileName: string, images: any[]): Promise<void> {
    let workbook = new ExcelJS.Workbook();
    const template = this.getTemplate(templateType);

    workbook = template.createTemplate(workbook, images);
    template.fillData(workbook, data);
    template.applyFormatting(workbook);

    await this.exportWorkbook(workbook, fileName);
  }

  private async exportWorkbook(workbook: ExcelJS.Workbook, fileName: string): Promise<void> {
    const buffer = await workbook.xlsx.writeBuffer();
    // const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    // saveAs(blob, fileName);

    // Create a download link and trigger download
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
